export default __webpack_public_path__ + "static/media/ssn.8e48e8a0.svg";